export default "__VITE_ASSET__n_d_gEAa__"